import React, { FC } from "react";

interface DiscountActiveStatusProps {
  isCurrentlyActive: boolean;
}

// Shared "Active" column renderer for all 6 discount-shaped list pages
// (Store/Shop/Brand/Category/ProductDiscountPage, plus the user-level
// DiscountPage) — factored out so a future change to how this status is
// displayed (e.g. a warning badge for a discount expiring within 24
// hours) only needs to land in one place instead of being copy-pasted
// into 6 files.
const DiscountActiveStatus: FC<DiscountActiveStatusProps> = ({ isCurrentlyActive }) => (
  <>{isCurrentlyActive ? "Yes" : "No"}</>
);

export default DiscountActiveStatus;
